import { isInTreatment } from './finch.coffee';
import { isSafariOrChromeIOS } from '../../helpers/isSafariOrChrome';

const TREATMENT = 'Treatment';
const SHELL_COOKIE = 'shell_page_pull';

export function enableShellLayout() {
  // debug
  if (new URLSearchParams(window.location).has('x-shell-debug')) {
    window.Cookie.set(SHELL_COOKIE, 'true');
    return;
  }

  let isBucketed;
  // check guard
  const isEnabled = isInTreatment('shell_exp_pull', TREATMENT);

  if (isEnabled) {
    // check finch experiment
    const exp = document.body.classList.contains('is-web')
      ? 'shell_desktop_v2'
      : 'shell_touch_v2';
    isBucketed = isInTreatment(exp, TREATMENT);
  }

  // housekeeping
  if (!isBucketed || isSafariOrChromeIOS(navigator.userAgent)) {
    window.Cookie.unset(SHELL_COOKIE);
  }
}
